import { createFileRoute } from '@tanstack/react-router'

import { ClientImportDetailPage } from '@/pages/clients/import/[id]/ClientImportDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/clients/import/$id/')({
  component: ClientImportDetailPage,
})
